define('SC.SummitThemeExtension.Address.Details', [
  'underscore',
  'SC.SummitThemeExtension.Common.LayoutHelper',
  'SC.SummitThemeExtension.Common.UtilitiesHelper'
], function SummitThemeExtensionAddressDetails(_, LayoutHelper, UtilitiesHelper) {
  'use strict';

  return {
    loadModule: function loadModule() {
      LayoutHelper.addToViewContextDefinition(
        'Address.Details.View',
        'extraAddressDetails',
        'object',
        function (context) {
          return {
            isMobile: UtilitiesHelper.isMobile(),
            uniqueid: context.manageOption + '-' + context.internalid
          };
        }
      );
    }
  };
});
